import gsap from "gsap";
import { useState, useRef, useEffect } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./features.css";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

export default function Features() {
    return (
        <div className="collage-container">
            {/* <div className="collage-text">
                <div className="line">
                    <span className="word medium">Speedometer </span>
                    <span className="word medium lite">Speedom</span>
                    <span className="word medium lite">eter  </span>
                    <span className="word medium">Tachometer </span>
                    <span className="word medium lite">Tachome</span>
                    <span className="word medium lite">ter </span>
                    <span className="word medium">Fuel Gauge </span>
                    <span className="word medium lite">Fuel Gauge</span>
                    <span className="word medium lite">Odometer </span>
                    <span className="word medium">Odometer </span>
                    <span className="word medium lite">Trip </span>
                    <span className="word medium lite">Meter </span>
                    <span className="word medium">Trip Meter </span>
                    <span className="word medium lite">Temp Gu</span>
                    <span className="word medium lite">age </span>
                    <span className="word medium">Temperature Guage </span>
                    <span className="word medium lite">and more </span>
                </div>
            </div> */}

            <div className="collage-text">
                <div className="line">
                    <span className="word medium">Speedometer </span>
                    <span className="word medium lite">Battery Volt</span>
                    <span className="word medium lite">age meter  </span>
                    <span className="word medium">Tachometer </span>
                    <span className="word medium">Fuel Guage </span>
                    <span className="word medium lite">Fuel Efficiency</span>
                    <span className="word medium lite">Guage </span>
                    <span className="word medium">Odometer </span>
                    <span className="word medium lite">Gear In</span>
                    <span className="word medium lite">dicator </span>
                    <span className="word medium">Trip Meter </span>
                    <span className="word medium lite">Distanc </span>
                    <span className="word medium lite">e to Empty </span>
                    <span className="word medium">Temperature G</span>
                    <span className="word medium">uage </span>
                    <span className="word medium lite">Tire Pressure Monito</span>
                    <span className="word medium lite">ring System </span>
                    <span className="word medium">and more </span>
                    <span className="word medium heart">❤️</span>
                </div>
            </div>

            {/* <table border={0}>
                <tr className="word table">
                    <td>Battery Voltage Meter<br />Oil Pressure Gauge<br />Fuel Efficiency Gauge<br />Transmission Temp Gauge<br />Gear Indicator</td>
                </tr>

                <tr className="word table">
                    <td>Boost Gauge<br />G-Force Meter<br />Lap Timer <br />Lap Timer <br />Air/Fuel Ratio Gauge</td>
                </tr>

                <tr className="word table">
                    <td>Battery Voltage Meter<br />Oil Pressure Gauge<br />Fuel Efficiency Gauge<br />Transmission Temp Gauge<br />Gear Indicator</td>
                </tr>

            </table> */}
        </div >
    );
}